import styled from 'styled-components';

export const ContactsWrapper = styled.div`
  position: relative;
  z-index: 2;
`;
